// API client for Malaria Detection FastAPI backend

const getBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  // Use relative path when served by FastAPI (static hosting)
  return '';
};

const jsonHeaders = { 'Content-Type': 'application/json' };

const safeFetch = async (path, options = {}, timeoutMs = 30000) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(`${getBaseUrl()}${path}`, { ...options, signal: controller.signal });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
      throw new Error(errorData.detail || `HTTP ${res.status}`);
    }
    return await res.json();
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Request timeout. Please try again.');
    }
    throw error;
  } finally {
    clearTimeout(timeout);
  }
};

// Health check
export const checkHealth = () => safeFetch('/health');

// Load model
export const loadModel = async (modelPath, modelType = 'efficientnet') => {
  return safeFetch(`/api/load-model?model_path=${encodeURIComponent(modelPath)}&model_type=${modelType}`, {
    method: 'POST'
  });
};

// Predict malaria from image
export const predictMalaria = async (imageFile, withGradCAM = false) => {
  const formData = new FormData();
  formData.append('file', imageFile);
  
  const endpoint = withGradCAM ? '/api/predict-with-cam' : '/api/predict';
  
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 60000); // 60s timeout for image processing
  
  try {
    const res = await fetch(`${getBaseUrl()}${endpoint}`, {
      method: 'POST',
      body: formData,
      signal: controller.signal
    });
    
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
      throw new Error(errorData.detail || `HTTP ${res.status}`);
    }
    
    return await res.json();
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Request timeout. Image processing is taking too long.');
    }
    throw error;
  } finally {
    clearTimeout(timeout);
  }
};

